import { IHospitalConfiguration, IUserDetails } from "../@types/Login";
import { IPortalPreferences } from "../@types/Preferences";
import {
  AUTH_HOSPITAL_CONFIGURATION,
  AUTH_PORTAL_PREFERENCES,
  AUTH_USER_DETAILS,
} from "../constants/localStorageKeys";
import { PMP_EMAIL_DOMAIN } from "../constants/pMpConstants";
import { ROLES } from "../utils/isSystemControllerUser";
import { safeJsonParse, safeStorage } from "../utils/storage";

export interface IUserRole {
  isSuperUser: boolean;
  isHospitalAdmin: boolean;
  enableRag: boolean;
  canViewRagTab: boolean;
  canEditRag: boolean;
}

export function useCurrentUserRole(): IUserRole {
  const userDetails = safeJsonParse<IUserDetails | undefined>(
    safeStorage.getItem(AUTH_USER_DETAILS),
    undefined
  );
  const portalPrefs = safeJsonParse<IPortalPreferences | undefined>(
    safeStorage.getItem(AUTH_PORTAL_PREFERENCES),
    undefined
  );
  const hospitalCfg = safeJsonParse<IHospitalConfiguration | undefined>(
    safeStorage.getItem(AUTH_HOSPITAL_CONFIGURATION),
    undefined
  );

  const email = userDetails?.userEmail?.toLowerCase() ?? "";
  const isSuperUser = email.endsWith(PMP_EMAIL_DOMAIN);
  // EN-5014: treat the Legacy Admin role as admin too, not just the legacy
  // is_admin flag, so admin gating stays correct if the two ever drift.
  const isHospitalAdmin =
    !isSuperUser &&
    (!!portalPrefs?.isAdmin || userDetails?.role === ROLES.LEGACY_ADMIN);
  const enableRag = !!hospitalCfg?.enableRag;

  return {
    isSuperUser,
    isHospitalAdmin,
    enableRag,
    canViewRagTab: isSuperUser || (isHospitalAdmin && enableRag),
    canEditRag: isSuperUser || (isHospitalAdmin && enableRag),
  };
}
